import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "50",
  height: "50",
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g filter=\"url(#__filter0_b_5613_22002)\"><rect width=\"50\" height=\"50\" rx=\"25\" fill=\"currentColor\" fill-opacity=\"0.28\"></rect><path d=\"M26.757 24.9991L19.332 17.5741L21.453 15.4531L30.999 24.9991L21.453 34.5451L19.332 32.4241L26.757 24.9991Z\" fill=\"currentColor\"></path></g><defs><filter id=\"__filter0_b_5613_22002\" x=\"-35\" y=\"-35\" width=\"120\" height=\"120\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feGaussianBlur in=\"BackgroundImageFix\" stdDeviation=\"17.5\"></feGaussianBlur><feComposite in2=\"SourceAlpha\" operator=\"in\" result=\"effect1_backgroundBlur_5613_22002\"></feComposite><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_backgroundBlur_5613_22002\" result=\"shape\"></feBlend></filter></defs>", 2)
  ])))
}
export default { render: render }